module.exports = __webpack_public_path__ + "img/gift.16b16b4a.png";